import { Grid, InputWrapper, Text } from '@mantine/core'
import { referenceDisplay } from '@seen/core/display'
import type { SDR } from '@seen/core/models/tasks/sdr/sdr'
import {
  SDRStatus,
  sdrStatusToMetadata,
} from '@seen/core/models/tasks/sdr/utils'
import type { JSX } from 'react'

type Props = {
  sdr: SDR
}

export function SDRDispositionResult({ sdr }: Props): JSX.Element | null {
  // Withdrawn SDRs may not have a disposition outcome (e.g., when revoked directly)
  if (!sdr.dispositionOutcome) {
    if (sdr.status === SDRStatus.WITHDRAWN) {
      return (
        <div className="space-y-4">
          <Text className="text-lg font-semibold">Decision Result</Text>
          <Text className="text-muted-foreground">
            This SDR was withdrawn without a formal disposition.
          </Text>
        </div>
      )
    }
    return null
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4">
        <Text className="text-lg font-semibold">Decision Result</Text>

        <Grid>
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <InputWrapper label="Disposition Outcome" className="grow">
              <Text>{sdrStatusToMetadata[sdr.dispositionOutcome].label}</Text>
            </InputWrapper>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 'auto' }}>
            <InputWrapper label="Rationale" className="grow">
              <Text>{sdr.dispositionRationale}</Text>
            </InputWrapper>
          </Grid.Col>
        </Grid>

        <InputWrapper label="Disposition Set By" className="grow">
          <Text>{referenceDisplay(sdr.dispositionInvolvedIDTMember)}</Text>
        </InputWrapper>
      </div>
    </div>
  )
}
